import { NavLink } from "react-router-dom";
import Logo from "../assets/images/logos/Red-white-black.png";

const Header = () => (
  <section className="header_wrapper">
    <div className="d-flex flex-column flex-root fixed-top">
      <div className="mb-0" id="home">
        <div className="landing-header">
          <div className="container">
            <div className="d-flex align-items-center">
              <NavLink exact to="/">
                <img alt="Logo" src={Logo} className="logo-default h-25px h-lg-30px" />
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Header;
